<template>
  <v-card :loading="showDialogProgress" :disabled="showDialogProgress">
  <div class="IOManagement">
    <request-management-search-panel
      :accessTo="accessTo"
      @search="setSearchParams"
    />

    <box class="mt-2" :title="$t('ioList')">
      <div class="ioList">
        <div v-if="list.length > 0">
          <IOManagementListWeb
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClickMission"
          />
          <IOManagementListMob
            @onClick="onClickMission"
            :list="list"
            class="hidden-md-and-up"
          />
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="d-flex px-4 py-2">
              <v-btn outlined color="primary" small :disabled="disabledBtn" @click="approveSelected">{{
                $t("approveSelected")
              }}</v-btn>
              <v-btn
                outlined
                color="primary"
                class="mx-2"
                small
                @click="rejectSelected"
                >{{ $t("rejectSelected") }}</v-btn
              >
            </div>
          </v-card-actions>
        </div>
        <div v-else>
          <EmptyList :state="stateList" />
        </div>
      </div>
    </box>
    <IOManagementDetails
      class="mt-2"
      ref="IOManagementDetails"
      @refresh="search"
      @operationOnRequest="operationOnRequestDetails"
    />
  </div>
</v-card>
</template>

<script>
import RequestManagementSearchPanel from "../../components/requestManagement/RequestManagementSearchPanel.vue";
import RequestState from "@/model/RequestState";
import ResultType from "../../model/ResultType";
import AccessToType from "../../model/AccessToType";
import IOManagementListWeb from "../../components/requestManagement/io/IOManagementListWeb.vue";
import IOManagementListMob from "../../components/requestManagement/io/IOManagementListMob.vue";
import IOManagementDetails from "../../components/requestManagement/io/IOManagementDetails.vue";
import TextUtils from "../../utils/TextUtils";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";
import StateList from "../../model/StateList";
import PushNotificationHelper from "../../notification/PushNotificationHelper";

export default {
  components: {
    RequestManagementSearchPanel,
    IOManagementListWeb,
    IOManagementListMob,
    IOManagementDetails,
  },
  data() {
    return {
      accessTo: -1,
      list: [],
      searchParams: {},
      stateList: null,
      reasonOfAdmin:"",
      showDialogProgress: false,
      disabledBtn:false,
   
    };
  },
  created() {
    this.accessTo = AccessToType.IO;
    //console.log(this.accessTo);
  },
  methods: {
    setSearchParams(params) {
      this.searchParams = params;
      this.search();
    },
    search() {
      this.stateList = StateList.loading();
      ////console.log(params);
      var params = this.searchParams;
      this.list = [];
      this.$store.dispatch("GetIoListForAdmin", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data;
          this.stateList = null;

        }
        else{
          this.stateList = null;
        }
      });
    },
    onClickMission(item) {
      this.hideDetails();
      //console.log(item);
      this.$refs.IOManagementDetails.show(item);
    },
    hideDetails() {
      this.$refs.IOManagementDetails.hide();
    },

   approveSelected() {
      this.disabledBtn=true;
      this.showDialogProgress=true
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Approve;
      this.OprationOnRequest(requestState, selectedList);
    },
    rejectSelected() {
      var selectedList = this.list.filter((item) => item.select === true);
      var requestState = RequestState.RequestState.Reject;
      var txtAdminParaf="";
      this.OprationOnRequest(requestState, selectedList,txtAdminParaf);
    },
    operationOnRequestDetails(requestState, selectedList,txtAdminParaf) {
      //debugger;
      this.reasonOfAdmin=txtAdminParaf,
      this.OprationOnRequest(requestState, selectedList,txtAdminParaf);
    },
   OprationOnRequest(requestState, selectedList,txtAdminParaf) {
      //console.log(selectedList);
      var params = [];
      var adminPerno = this.$store.state.auth.auth.username;

      if (EosUtils.isWebKartAdmin()) {
        //
        selectedList.forEach((item) => {
          var param = {
            PageNo: TextUtils.convertToEnglishDigits(
              item.PageNo.toString().trim()
            ),
            Year: TextUtils.convertToEnglishDigits(item.ClockDate.substr(0, 4)),
            adminPerno: adminPerno,
            perno: TextUtils.convertToEnglishDigits(
              item.Perno.toString().trim()
            ),
            RequestState: requestState,
            ReasonOfAdmin: txtAdminParaf,
            Status: 10,
          };
          params.push(param);
        });
        this.OprationOnIORequest(params);
      } else {
        //
        let callback = function (resList) {
          //console.log(resList);
          resList.forEach((res, index) => {
            if (res.type === ResultType.success) {
              var s = res.data;
              //console.log(s, index);
              var item = selectedList[index];
              var param = {
                PageNo: TextUtils.convertToEnglishDigits(
                  item.PageNo.toString().trim()
                ),
                Year: TextUtils.convertToEnglishDigits(item.ClockDate.substr(0, 4)),
                adminPerno: adminPerno,
                perno: TextUtils.convertToEnglishDigits(
                  item.Perno.toString().trim()
                ),
                RequestState: requestState,
                ReasonOfAdmin: txtAdminParaf,
                Status: s,
              };
              params.push(param);
            }
          });
        };
        if (selectedList.length > 0) {
          this.GetApproveDegree(selectedList, callback).then(() => {
            this.OprationOnIORequest(params);
          });
        }
      }
    },
    async GetApproveDegree(list, callback) {
      let promises = [];
      list.forEach((item) => {
        //console.log(item);
        var approveParams = {
          perno: TextUtils.convertToEnglishDigits(item.Perno.toString().trim()),
          section: TextUtils.convertToEnglishDigits(
            item.Section.toString().trim()
          ),
          status: TextUtils.convertToEnglishDigits(
            item.Status.toString().trim()
          ),
          pageType: TextUtils.convertToEnglishDigits(
            item.Type.toString().trim()
          ),
        };

        promises.push(
          this.$store.dispatch("GetIOApproveDegree", { approveParams })
        );
      });

      await Promise.all(promises)
        .then(callback)
        .catch((err) => {
          console.log(err);
        });
    },
    OprationOnIORequest(params) {
      //console.log(params);
      this.disabledBtn = true; // Disable the button
      this.showDialogProgress = true; // Show progress dialog

      this.$store.dispatch("OprationOnIORequest", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.search();
          if (result.data && result.data.length > 0) {
            var description = result.data[0].Description;
            this.$EosToast.show({
              type: EosToastType.success,
              msg: description,
            });
            this.disabledBtn = false;
            this.showDialogProgress = false;
            //this.$refs.snackbar.show("success", description);
            params.forEach((param) => {
                PushNotificationHelper.sendNotification(
                  param.adminPerno,
                  param.perno,
                  param.RequestState,
                  param.RequestState
                );
              });
          }
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error,
          });
          this.disabledBtn = false;
          this.showDialogProgress = false;
          //this.$refs.snackbar.show("error", result.error);
        }
      });
    },
  },
};
</script>

<style>
</style>
